import { ScrollUtils } from '@shared/utils';

class Registry {
  private _layers: any[] = [];
  private _hooksActive = false;
  private _lastEscStamp?: number;

  addLayer(layer: any) {
    this._layers.push(layer);
  }

  removeLayer(layer: any) {
    const i = this._layers.indexOf(layer);
    if (i >= 0) {
      this._layers.splice(i, 1);
    } else {
      console.warn('[PopupRegistry] no layer was removed');
    }
  }

  layer() {
    if (this._layers.length === 0) {
      return {
        updateWindow: () => {},
        removeWindow: () => {},
        rejectLast: () => false,
      };
    }
    return this._layers[0];
  }

  layerShown() {
    ScrollUtils.scroll.disable();
    this.checkHooks();
  }

  layerHidden() {
    this.checkHooks();
    ScrollUtils.scroll.enable();
  }

  checkHooks() {
    const visibleCount = this._layers.reduce((acc, layer) => acc + layer.internalState.visible.length, 0);
    const hooksActive = visibleCount > 0;
    if (this._hooksActive !== hooksActive) {
      if (hooksActive) this.setHooks();
      else this.removeHooks();
    }
  }

  private setHooks() {
    this._hooksActive = true;
    ScrollUtils.scroll.disable();
    document.addEventListener('keydown', this._handleEsc);
  }

  private removeHooks() {
    this._hooksActive = false;
    document.removeEventListener('keydown', this._handleEsc);
    ScrollUtils.scroll.enable();
  }

  private _handleEsc = (e: KeyboardEvent) => {
    if (e.key !== 'Escape') return;

    if (this._lastEscStamp === e.timeStamp) {
      return;
    }
    this._lastEscStamp = e.timeStamp;
    for (let k = this._layers.length - 1; k >= 0; k--) {
      const layer = this._layers[k];
      if (layer && layer.rejectLast()) {
        return;
      }
    }
  };
}

export const registry = new Registry();
